import { app } from '../../../app';
import { Controller } from './pin-reset.controller';

app.component('pinReset', {
    templateUrl: require('./pin-reset.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/pin-reset/pin-reset.component.js